module.exports = __webpack_public_path__ + "./docs/img/icon-object.1260713f30944a1385e4f58755e99d57.svg";